const isHtmlOffsetElement = (node: Element): node is HTMLElement => 'offsetTop' in node

export function getFullOffsetOfElement(element: HTMLElement): number {
  const { offsetParent, offsetTop } = element
  if (offsetParent === null || !isHtmlOffsetElement(offsetParent)) {
    return 0
  }
  return offsetTop + getFullOffsetOfElement(offsetParent)
}
